import "framework7";
import "framework7/dist/css/framework7.ios.css";

interface Button {
  text: string;
  bold?: boolean;
  color?: string;
  bg?: string;
  label?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}
interface F7Interface {
  /** @deprecated All (imperative) usages of Framework7 should be removed */
  alert(text: string, title?: string, callback?: () => void): HTMLElement;
  /** @deprecated All (imperative) usages of Framework7 should be removed */
  alert(text: string, callback?: () => void): HTMLElement;
  /** @deprecated All (imperative) usages of Framework7 should be removed */
  confirm(text: string, title?: string, callbackOk?: () => void, callbackCancel?: () => void): HTMLElement;
  /** @deprecated All (imperative) usages of Framework7 should be removed */
  confirm(text: string, callbackOk?: () => void, callbackCancel?: () => void): HTMLElement;
  /** @deprecated All (imperative) usages of Framework7 should be removed */
  prompt(text: string, title?: string, callbackOk?: (input: string) => void, callbackCancel?: (input: string) => void): HTMLElement;
  /** @deprecated All (imperative) usages of Framework7 should be removed */
  prompt(text: string, callbackOk?: (input: string) => void, callbackCancel?: (input: string) => void): HTMLElement;
  /** @deprecated All (imperative) usages of Framework7 should be removed */
  showIndicator(): void;
  /** @deprecated All (imperative) usages of Framework7 should be removed */
  hideIndicator(): void;
  /** @deprecated All (imperative) usages of Framework7 should be removed */
  modal(parameters: {
    title?: string;
    text?: string;
    afterText?: string;
    buttons: { text: string; bold?: boolean; close?: boolean; onClick?: () => void }[];
    verticalButtons?: false;
    onClick?: (modal: HTMLElement, index: number) => void;
  }): HTMLElement;

  /** @deprecated All (imperative) usages of Framework7 should be removed */
  openPanel(position: "left" | "right", animated?: boolean): void;
  /** @deprecated All (imperative) usages of Framework7 should be removed */
  closePanel(animated?: boolean): void;

  /** @deprecated All (imperative) usages of Framework7 should be removed */
  sortableOpen(sortableContainer: string | HTMLElement): void;
  /** @deprecated All (imperative) usages of Framework7 should be removed */
  sortableClose(sortableContainer: string | HTMLElement): void;
  /** @deprecated All (imperative) usages of Framework7 should be removed */
  sortableToggle(sortableContainer: string | HTMLElement): void;

  /** @deprecated All (imperative) usages of Framework7 should be removed */
  actions(groups: Button[][], animated?: boolean): void;
  /** @deprecated All (imperative) usages of Framework7 should be removed */
  actions(buttons: Button[], animated?: boolean): void;

  /** @deprecated All (imperative) usages of Framework7 should be removed */
  photoBrowser(parameters: {
    photos: string[] | { url: string; caption: string }[];
    initialSlide?: number;
    type: "standalone" | "popup" | "page";
    toolbar?: boolean;
    exposition?: boolean;
  }): { open(): void };

  /** @deprecated All (imperative) usages of Framework7 should be removed */
  picker(parameters: {
    input: string | HTMLElement;
    inputReadOnly?: boolean;
    convertToPopover?: boolean;
    value: string[];
    closeByOutsideClick?: boolean;
    onChange?: (e: Event, values: string[], displayValues: string[]) => void;
    toolbarTemplate?: string;
    cols: { values: string[] }[];
  }): {};
}

const F7: F7Interface = new (window as any).Framework7({
  tapHold: false,
  material: false,
});
export default F7;
